<script setup lang="ts">
import {formatting, Models, useDialogs, useOrderViewContext} from '@hantera/portal-app'
import useBackend from "@/composition/useBackend";

const props = defineProps<{
  capture: Models.Graph.PaymentCapture
}>()

const orderViewContext = useOrderViewContext()
const dialogs = useDialogs()
const backend = useBackend()

async function complete() {
  
  if (await dialogs.confirm(
    `${formatting.currency(-props.capture.remainingAmount, orderViewContext.state.currencyCode)} will be assigned to the payment's credit balance. This action will be committed immediately.`,
    'Are you sure?',
    undefined,
    undefined,
    true
  )) {
    
    const response = await backend.fetch(
      `/core/resources/actors/payment/${props.capture.payment.paymentId}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify([{
          type: 'completeCapture',
          body: {
            captureId: props.capture.paymentCaptureId
          }
        }])
      }
    )
    
    if (!response.ok) {
      // TODO Move to new error service once it exists
      await dialogs.alert(await response.text(), 'Error');
      return;
    }
    
    await orderViewContext.refresh()
    
  }
  
}

</script>

<template>
  <div class="capture box-content p">
    <div
      class="capture__state"
      :style="`background-color: var(--state-${capture.state})`"
      :title="capture.state"
    ></div>

    <div>
      <div class="capture__payment-number">{{capture.invoice.invoiceNumber}}</div>
    </div>

    <div class="capture__balance">
      {{formatting.currency(capture.amount, orderViewContext.state.currencyCode)}}
    </div>

    <div v-if="!capture.remainingAmount.eq(0)" class="capture__remaining">
      <div>Remaining: {{formatting.currency(capture.remainingAmount, orderViewContext.state.currencyCode)}}</div>
      <div><button class="btn-link" @click="complete">Complete</button></div>
    </div>
    
    {{(''/* TODO Add app view for apps to show additional info and links */)}}
  </div>
</template>

<style scoped>

.capture {
  position: relative;
  
  padding-left: 10px;
  
  display: grid;
  grid-template-columns: auto max-content;
}

.capture__state {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  border-radius: 5px;
}

.capture__balance {
  text-align: right;
}

.capture__remaining {
  grid-column: 1 / 3;
  grid-row: 2 / 3;
  
  display: flex;
  justify-content: space-between;
}


</style>